import { ROUTE_NAMES } from '@/utils/const.js';
import { USER_ACTIONS, USER_SUBJECTS } from '@/utils/const';
const Inspections = () => import('./pages');

const moduleRoute = {
  path: 'quality/inspections',
  name: 'Inspections',
  component: Inspections,
  meta: {
    allowAnonymous: false,
    ability: {
      subject: USER_SUBJECTS.INSPECTIONS,
      action: USER_ACTIONS.READ,
    },
    isNextAppPage: true,
  },
};

export default (router) => {
  router.addRoute(ROUTE_NAMES.BASE_LAYOUT, moduleRoute);
};
